export default __webpack_public_path__ + "images/assets/e40c717baf54cd44627cd7d95c686aac.svg";